// extracted by mini-css-extract-plugin
module.exports = {"main":"InvitePill_main__7ZzWL","iconDiv":"InvitePill_iconDiv__EHSuT","text":"InvitePill_text__sX5y_"};